module.exports = "static/webpack/025edce751114ac8c36d43629c67cabc.png";